<template>
  <div>
    <div class="__header-container">
      <h4 class="__header-text">Tarif Harga {{ rowIdx + 1 }}</h4>
      <McButton
        variant="secondary-red"
        :text="$t('global.delete')"
        icon="icon-outline_trash"
        @click="triggerDelete"
      />

      <McButton variant="primary" text="Simpan" icon="icon-outline_save" @click="triggerSubmit" />
    </div>

    <FormulateForm name="rates-form" v-model="model" @submit="handleSubmit">
      <b-row>
        <b-col md="6" v-for="group in addressFieldsGroups" :key="group.name">
          <h5>{{ group.label }}</h5>
          <b-row>
            <b-col md="6" v-for="field in group.fields" :key="field.name">
              <FormulateInput
                v-bind="field"
                :name="`${group.name}_${field.name}`"
                :initialObject="field.getInitialObject?.(formValues[`${group.name}_${field.name}`])"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" v-for="field in rateDetailFields" :key="field.name">
          <FormulateInput v-bind="field" :initialObject="field.getInitialObject?.(rate)" />
        </b-col>
      </b-row>

      <div class="__base-price-container">
        <div class="__base-price">
          <div>
            <h5>Tarif Dasar</h5>

            <div class="validation">
              <strong>*</strong>
              <span>Wajib Diisi</span>
            </div>
          </div>

          <FormulateInput
            name="base_price"
            validation="bail|required|number|min:0,value|integer"
            type="text"
            label="Tarif Dasar"
            error-class="mt-1"
          />
        </div>
      </div>
    </FormulateForm>

    <b-modal
      title="Hapus Tarif Harga?"
      ref="mc-modal-delete"
      size="md"
      centered
      scrollable
      hide-header-close
    >
      <div>
        <p>Apakah anda yakin ingin menghapus tarif harga ini?</p>
        <p>Data yang sudah terhapus tidak bisa dikembalikan.</p>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton @click="cancel()" variant="secondary" class="me-2" text="Tidak" />
          <McButton @click="deleteConfirmed" variant="primary" text="Ya" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    rowIdx: {
      type: Number,
      default: 0,
    },
    addressFieldsGroups: {
      type: Array,
      default: () => [],
    },
    rateDetailFields: {},
    rate: {
      type: Object,
      default: () => ({}),
    },
    formValues: {},
  },
  emits: ['triggerDelete', 'triggerSave'],
  computed: {
    model: {
      get() {
        return this.formValues
      },
      set(value) {
        // TODO: Careful of unnecessary emits
        // console.log("emitted formvalues")

        // Reset value if type changed
        if (this.formValues.origin_type != value.origin_type) {
          delete value.origin_name
        }

        if (this.formValues.destination_type != value.destination_type) {
          delete value.destination_name
        }

        this.$emit('update:formValues', value)
      },
    },
  },
  methods: {
    async handleSubmit(data) {
      this.$emit('triggerSave', data)
    },

    triggerSubmit() {
      this.$formulate.submit('rates-form')
    },

    triggerDelete() {
      this.$refs['mc-modal-delete'].show()
    },
    deleteConfirmed() {
      this.$refs['mc-modal-delete'].hide()
      this.$emit('triggerDelete')
    },
  },
}
</script>
